import style from "./catalogs.module.scss";
import Nav from "../../components/ui/nav/nav";
import {useCatalogs} from "../../hooks/catalogs.hook";
import CatalogItem from "./components/catalogItem";
import {useState} from "react";
import CreateCatalog from "./popup/createCatalog";
import {closestCenter, DndContext} from "@dnd-kit/core";
import {SortableContext, verticalListSortingStrategy} from "@dnd-kit/sortable";
import {restrictToVerticalAxis, restrictToParentElement} from '@dnd-kit/modifiers';
import {useSortableList} from "./hoock/useSortableList";
import ConfirmDeletePopup from "../../components/popups/confirmDeletePopup";

const CatalogsPage = () => {

    const [parentId, setParentId] = useState(-1)
    const {catalogs, create, update, deleteCatalogs, updateOrder} = useCatalogs(parentId)
    const [popupData, setPopupData] = useState({visible: false, categoryId: -1, data: {}})
    const [catalogToDelete, setCatalogToDelete] = useState(null)
    const {items, handleDragEnd} = useSortableList(catalogs);

    const dragEnd = (e) => {
        const newItems = handleDragEnd(e)
        const newIds = newItems.map(item => item.id);
        updateOrder({orders: newIds, parentId: parentId})
    }

    return (
        <div className="page">
            <div className="page_container">
                <div className={style.block}>
                    <CreateCatalog active={popupData} setActive={setPopupData} create={create} data={popupData.data}
                                   update={update}/>
                    <ConfirmDeletePopup
                        active={catalogToDelete && {
                            title: catalogToDelete.isCategory ? "Удалить каталог?" : "Удалить подкаталог?",
                            message: `«${catalogToDelete.name}» будет удален без возможности восстановления.`
                        }}
                        onCancel={() => setCatalogToDelete(null)}
                        onConfirm={() => {
                            deleteCatalogs({
                                id: catalogToDelete.id,
                                isCategory: catalogToDelete.isCategory
                            });
                            setCatalogToDelete(null);
                        }}
                    />
                    <Nav title={"Каталоги"}>
                        <div className={style.body}>
                            <div className={style.row}>
                                <button
                                    className={parentId !== -1 ? style.btnBack : [style.btnBack, style.btnBackDisabled].join(" ")}
                                    onClick={() => {
                                        setParentId(-1)
                                        setPopupData({visible: false, categoryId: -1, data: {}})
                                    }}>Назад
                                </button>
                                <button className={style.btnCreate} onClick={() => setPopupData({
                                    visible: true,
                                    categoryId: parentId,
                                    data: {}
                                })}>Добавить
                                </button>
                            </div>
                            <div className={style.table}>
                                <div className={style.tableHeader}>
                                    <div>Название</div>
                                    <div>Публикация</div>
                                    <div>Кол-во подкатегорий</div>
                                </div>
                                <div className={style.tableBody} style={{overflowX: "hidden"}}>
                                    <DndContext
                                        collisionDetection={closestCenter}
                                        onDragEnd={dragEnd}
                                        modifiers={[restrictToVerticalAxis,
                                            restrictToParentElement,]}
                                    >
                                        {items?.length > 0 &&
                                            <SortableContext
                                                items={items}
                                                strategy={verticalListSortingStrategy}
                                                style={{overflowX: "hidden"}}
                                            >
                                                {items?.length > 0 && items.map((catalog) => (
                                                    <CatalogItem key={catalog.id} catalog={catalog} parentId={parentId}
                                                                 setParentId={setParentId} update={update}
                                                                 requestDelete={(catalog) => setCatalogToDelete({
                                                                     id: catalog.id,
                                                                     name: catalog.name,
                                                                     isCategory: parentId === -1
                                                                 })}
                                                                 openCreatePopup={setPopupData}/>
                                                ))}
                                            </SortableContext>}
                                    </DndContext>
                                </div>
                                <div className={style.tableFooter}>
                                    <div>Всего: {catalogs?.length || 0}</div>
                                </div>
                            </div>
                        </div>
                    </Nav>
                </div>
            </div>
        </div>
    );
};

export default CatalogsPage;